import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { AvatarPipe } from 'app/core/pipes/avatar.pipe';
import { ToastService } from 'app/core/services/toast.service';
import { ActivitiesService } from 'app/modules/activities/activities.service';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'app-activity-logs',
  standalone: true,
  imports: [RouterLink, DatePipe, MatIconModule, FuseCardComponent, AvatarPipe, MatProgressSpinnerModule],
  templateUrl: './activity-logs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityLogsComponent implements OnChanges {
  private toast = inject(ToastService);
  private Activity = inject(ActivitiesService);
  private auth = inject(AuthService);
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);

  profile: any;
  dataLoader = false;
  dataList: any = [];
  where: any = [];
  order: any = { created_at: 'desc' };
  include: any = ['causer'];
  paginator: any = {
    itemsPerPage: 20,
    currentPage: 1,
    totalItems: 0,
    form: 0,
    to: 0,
  };
  error: string = null;

  @Input() fromDate: any = '';
  @Input() toDate: any = '';

  ngOnChanges(changes: SimpleChanges) {
    this.dataLoader = true;
    this.profile = this.auth.profile();
    this.getData();
  }

  public getData() {
    this.error = null;
    this.dataList = [];
    this.dataLoader = true;
    // Rebuilt on every call so paging does not stack duplicate causer filters.
    this.where = [];
    if (!this.auth.canAccess('activity_logs_other')) {
      this.where.push({ column: 'causer_id', operator: '=', value: this.profile.id }, { column: 'causer_type', operator: '=', value: 'user' });
    }

    this.Activity.getList({ where: this.where, orderBy: this.order, include: this.include }, this.paginator.currentPage, this.paginator.itemsPerPage)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (data: any) => {
          if (data.status === 'success') {
            this.dataList = data.record;
          } else if (data.status === 'error') {
            this.toast.error(data.error.message);
          }
          this.dataLoader = false;
          this.cdr.markForCheck();
        },
        (error: any) => {
          this.error = error.message;
          this.dataLoader = false;
          this.cdr.markForCheck();
        }
      );
  }
}
